import { render } from "./Permissions.vue?vue&type=template&id=997ea9ec&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"

import "./Permissions.vue?vue&type=style&index=0&id=997ea9ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-997ea9ec"

export default script